import { render, staticRenderFns } from "./SpecificationModal.vue?vue&type=template&id=458e9126&scoped=true&"
import script from "./SpecificationModal.vue?vue&type=script&lang=js&"
export * from "./SpecificationModal.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationModal.vue?vue&type=style&index=0&id=458e9126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e9126",
  null
  
)

export default component.exports